import { render, staticRenderFns } from "./main-window.vue?vue&type=template&id=93d597b2&"
import script from "./main-window.vue?vue&type=script&lang=js&"
export * from "./main-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports